import Image from 'next/legacy/image'

import downloadAndroid from './google-play.png'

const width = height => Math.round((270 / 80) * height)

const AndroidButton = ({ height = 40 }) => (
  <Image
    src={downloadAndroid}
    height={height}
    width={width(height)}
    alt="Download liv.rent Android App"
    placeholder="blur"
  />
)

export default AndroidButton
